import { render, staticRenderFns } from "./storeTraditRecord.vue?vue&type=template&id=478b98e8"
import script from "./storeTraditRecord.vue?vue&type=script&lang=js"
export * from "./storeTraditRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports